const tabuleoSubscription = {
  tabuleoSubscriptions: "Abonnements Tabuléo",
  nbStudentTeacher: "Nombre d'élèves et de professeurs",
  getSubscriptionsError:
    "Une erreur est survenue lors de la récupération des abonnements Tabuléo.",
  getSubscriptionError:
    "Une erreur est survenue lors de la récupération des détails de l'établissement.",
  nbrStudent: "Nombre d'élèves",
  nbrTeacher: "Nombre d'enseignants",
};

export default tabuleoSubscription;
